import React from 'react'

import clsx from 'clsx'

import Icon from 'components/Icon'

import classes from './BreadcrumbRoot.module.scss'

/** @type {import("./types").default} */
const BreadcrumbRoot = ({ children, className, ...rest }) => {
  return (
    <nav className={clsx('BreadcrumbRoot', classes.root, className)} {...rest}>
      <ol className={clsx(classes.list, classes.itemWrapper)}>
        {React.Children.toArray(children).map((child, index, arr) => {
          return (
            <React.Fragment key={`BreadcrumbItem-${index}`}>
              <li className={classes.item} data-testid="item">
                {child}
              </li>
              {index < arr.length - 1 && (
                <li className={classes.separator} data-testid="separator">
                  <Icon icon="angle-right" />
                </li>
              )}
            </React.Fragment>
          )
        })}
      </ol>
    </nav>
  )
}

export default BreadcrumbRoot
